import styled from "styled-components"

const SubHeaderDetailStyled = styled.div`
  padding: 0 1rem 1.5rem;
  background: ${({ theme }) => theme.palette.grey5};

  .box-alert-styled {
    display: flex;
    background-color: #fff3cd;
    border: 1px solid #fdcb6e;
    padding: 0.5rem 1rem;
    border-radius: 8px;

    &.inline {
      display: inline-flex;
    }
  }
`
export default SubHeaderDetailStyled
